import { changeAdded, changeUpdated } from "./resourceChangeReportSlice";

const updateChangeReport = (dispatch, resourceChanges, foi, 
    datatype, path, originalValue, newValue) => {
    let changeExists = false;
    let changeId = "";
    for (let change of resourceChanges) {
        if (change.resourceId === foi &&
            change.originalDatatype === datatype &&
            change.originalPath === path &&
            JSON.stringify(change.originalValue) === JSON.stringify(originalValue)) {
            changeExists = true;
            changeId = change.id;
            break;
        }
    }
    console.log("change reported for FOI at path from orignalValue to newValue (? changeExists):");
    console.log(resourceChanges)
    console.log("-------------------------------")
    console.log(foi);
    console.log(path);
    console.log(originalValue);
    console.log(newValue);
    console.log(changeExists);
    const currenttime = new Date().toISOString();
    if (changeExists) {
        dispatch(changeUpdated({
            id: changeId,
            resourceId: foi,
            originalDatatype: datatype,
            originalPath: path,
            originalValue: originalValue,
            newDatatype: datatype,
            newPath: path,
            newValue: newValue,
            changeComment: null,
            dateCreated: currenttime
        }));
    } else {
        dispatch(changeAdded({
            id: resourceChanges.length,
            resourceId: foi,
            originalDatatype: datatype,
            originalPath: path,
            originalValue: originalValue,
            newDatatype: datatype,
            newPath: path,
            newValue: newValue,
            changeComment: null,
            dateCreated: currenttime
        }));
    }
};

export default updateChangeReport;